import { render, staticRenderFns } from "./ReviewPreview.vue?vue&type=template&id=ab0664fa&scoped=true&"
import script from "./ReviewPreview.vue?vue&type=script&lang=js&"
export * from "./ReviewPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPreview.vue?vue&type=style&index=0&id=ab0664fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0664fa",
  null
  
)

export default component.exports